import UserRoles from '../DefinedData/UserRoles';
import DefinedRouteAlias from '../DefinedData/DefinedRouteAlias';
import Vue from 'vue';

Vue.use(require('vue-cookies'));
const UserMenuRoleModuleAssignment = {
    definedAssignments: {
        [UserRoles.ADMIN]: {
            modules: 'all',
            initRoute: '/dashboard',
        },
        [UserRoles.RENTAL_MANAGER]: {
            modules: [
                {
                    name: DefinedRouteAlias.Rental.label,
                    permission: {
                        read: true,
                        write: true,
                    },
                },
            ],
            initRoute: DefinedRouteAlias.Rental.url,
        },
        [UserRoles.RENTAL_EMPLOYEE]: {
            modules: [
                {
                    name: DefinedRouteAlias.Rental.label,
                    permission: {
                        read: true,
                        write: false,
                    },
                },
            ],
            initRoute: DefinedRouteAlias.Rental.url,
        },
        [UserRoles.MOORAGE_MANAGER]: {
            modules: [
                {
                    name: DefinedRouteAlias.Moorage.label,
                    permissions: {
                        read: true,
                        write: true,
                    },
                },
            ],
            initRoute: DefinedRouteAlias.Moorage.url,
        },
        [UserRoles.MOORAGE_EMPLOYEE]: {
            modules: [
                {
                    name: DefinedRouteAlias.Moorage.label,
                    permissions: {
                        read: true,
                        write: false,
                    },
                },
            ],
            initRoute: DefinedRouteAlias.Moorage.url,
        },
    },
    getNavItemsAssignments: (userRole) => {
        const items = [];
        const assignment =
            UserMenuRoleModuleAssignment.definedAssignments[userRole];
        for (const i in DefinedRouteAlias) {
            if (assignment?.modules === 'all') {
                items.push(DefinedRouteAlias[i]);
            } else {
                const isHavingAccess = assignment?.modules.find(
                    (assignedModule) =>
                        assignedModule.name === DefinedRouteAlias[i].label
                );
                if (typeof isHavingAccess !== 'undefined') {
                    assignment?.modules.forEach((moduleItem) => {
                        items.push(DefinedRouteAlias[moduleItem.name]);
                    });
                }
            }
        }

        return items;
    },
    getUserRoleInitRoute(userRole) {
        return UserMenuRoleModuleAssignment.definedAssignments[userRole]
            .initRoute;
    },
    isRoleHasWritePermission: (moduleName) => {
        const userAuth = Vue.$cookies.get('_user');
        const modules =
            UserMenuRoleModuleAssignment.definedAssignments[userAuth.role]
                .modules;
        if (modules === 'all') {
            return true;
        }

        const assignment = modules.find(
            (moduleItem) => moduleItem.name === moduleName
        );

        return assignment.permission.write;
    },
};

export default UserMenuRoleModuleAssignment;
